'use client';

import React, { HTMLAttributes, useEffect, useState } from 'react';

import VillageCard from '../VillageCard';
import useLocalStorage from '@/hooks/useLocalStorage';
import { Village } from '@/services/types';
import { WishList } from '../VillageCard/Options';
import { useGallery } from '@/hooks/useGalleryContext';

interface IVillageCarouselOptionsProps extends HTMLAttributes<HTMLDivElement> {
  village: Village;
}

export const VillageCarouselOptions: React.FC<IVillageCarouselOptionsProps> = ({
  village,
}) => {
  const [wishList, setWishList] = useLocalStorage('villas', [] as WishList[]);
  const { changeVillageInfo } = useGallery();

  return (
    <>
      <VillageCard.Options
        wishList={wishList}
        setWishList={setWishList}
        onGalleryClick={changeVillageInfo}
        village={village}
      />
    </>
  );
};
